import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Col, Divider, Row } from 'antd';

import { setAppLoader } from '../../../../../../redux/common/CommonActions';
import { shipmentEndSpotBidInProgress } from '../../../../../../redux/shipment/ShipmentActions';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import Button from '../../../../../components/Buttons/Button';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import { SHIPMENT_STATUS } from '../../../constants';
import AddBidderForm from './AddBidderForm';
import CloseSportBidForm from './CloseSportBidForm';
import SportBidForm from './SportBidForm';

const SpotBidDetails = ({ handleSpotBidSuccess = () => false, submitSpotBidButtonContainerClassName }) => {
  const dispatch = useDispatch();
  const { shipmentDetails } = useSelector((state) => state.shipment);
  const shipmentStatus = shipmentDetails?.data?.status;
  const { user, selectedCompany } = useSelector((state) => state.auth);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const [addBidderFormVisible, setAddBidderFormVisible] = useState(false);

  const handleEndSpotBid = () => {
    const payload = {
      callBackFun: () => {
        handleSpotBidSuccess();
      },
      customerKey: selectedCompany.companyId,
      ShipmentKey: shipmentDetails?.data?.shipmentKey,
      UserId: user.data.id,
    };
    dispatch(setAppLoader(true));
    dispatch(shipmentEndSpotBidInProgress(payload));
  };

  const handleSpotBidSuccessLocal = () => {
    handleSpotBidSuccess();
    setAddBidderFormVisible(false);
  };

  return (
    <div>
      {shipmentStatus === SHIPMENT_STATUS.SpotBid ? (
        <>
          <Row justify="space-between" align="middle" className="my-15">
            <Col className="mb-3">
              <PrimaryLabel className="text-highlight f-18 ">
                {t('translation:shipmentAdd.spotBid.shipmentForSpotBid')}
              </PrimaryLabel>
            </Col>
            <Col>
              <Row align="middle" gutter={15}>
                <Col>
                  <Button type="primary" variant="danger" onClick={handleEndSpotBid}>
                    {t('translation:shipmentAdd.spotBid.endSpotBid')}
                  </Button>
                </Col>
                <Col>
                  <Button disabled={addBidderFormVisible} type="primary" onClick={() => setAddBidderFormVisible(true)}>
                    {t('translation:shipmentAdd.spotBid.addBidder')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider className="m-0 mb-15" />
          {addBidderFormVisible ? (
            <AddBidderForm
              handleSpotBidSuccess={handleSpotBidSuccessLocal}
              setAddBidderFormVisible={setAddBidderFormVisible}
            />
          ) : (
            <CloseSportBidForm
              handleSpotBidSuccess={handleSpotBidSuccess}
              setAddBidderFormVisible={setAddBidderFormVisible}
            />
          )}
        </>
      ) : (
        <SportBidForm
          handleSpotBidSuccess={handleSpotBidSuccessLocal}
          submitSpotBidButtonContainerClassName={submitSpotBidButtonContainerClassName}
        />
      )}
    </div>
  );
};

export default SpotBidDetails;
